import Framework7 from "framework7";

export default {
  subscribe(name, email) {
    Framework7.request.promise.post(`/.netlify/functions/subscribe`, { name, email }).catch(() => {});
  }
};